import { ComponentCategory } from './component-category.class';
import { ComponentCategoriesData, ComponentCategoriesDataIn, ComponentCategoryData } from './types';

import { categoryData } from '../data/category.data';
import { ComponentOptions } from '../types';

export class ComponentCategories extends Array<ComponentCategory> {
	#userEmail: string;

	constructor (options: ComponentOptions<ComponentCategoriesDataIn>) {
		super();

		this.#userEmail = options?.userEmail ?? 'SYSTEM';

		if (options.dataIn && options.dataIn.length > 0) {
			options.dataIn.forEach((n) => this.push(new ComponentCategory({ userEmail: this.#userEmail, dataIn: n })));
		} else {
			this.load();
		}
	}

	/**
	 *
	 * @param newComponentCategoryData ComponentCategoryData of component category to add
	 * @returns unique identified of added component category
	 */
	public add (newCategoryData: Partial<ComponentCategoryData>): string {
		const newRecord = new ComponentCategory({ userEmail: this.#userEmail, dataIn: newCategoryData });
		this.push(newRecord);
		return newRecord.id;
	}

	/**
	 *
	 * @param id category id to look up
	 * @returns Category
	 */
	public findById (id: string): ComponentCategory {
		const category = this.find((record) => record.id === id) as ComponentCategory || null;
		return category;
	}

	/**
	 * @returns Array of active categories
	 */
	public getActiveEntries (): Array<ComponentCategory> {
		// not sure why this isn't working
		// return this.filter((c) => c.active);

		const entries: Array<ComponentCategory> = [];
		this.forEach((c) => { if (c.active) entries.push(c); });
		return entries;
	}

	// loads json, returns record count loaded
	// TODO: loaders should be an injectable interface to allow for external sources
	public load (): number {
		// purge before load
		if (this.length > 0) this.splice(0, this.length);

		// load data
		let loadCounter = 0;
		categoryData.forEach((category) => {
			loadCounter++;
			this.add(category);
		});

		return loadCounter;
	}

	/**
	 *
	 * @returns serialized data representing class state for persistence
	 */
	public serialize ():ComponentCategoriesData {
		return this.map((record: ComponentCategory) => record.serialize());
	}
}
